import { Location } from '@angular/common';
import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { SharedModule } from '@shared/shared.module';
import { BaseComponent } from 'projects/shared/src/lib/shared/base/components/base-component';
import { ForbiddenService } from 'projects/shared/src/lib/shared/services/local/forbidden.service';
import { NotFoundService } from 'projects/shared/src/lib/shared/services/local/not-found.service';

import { AppRoute } from '../../../shared/app.route.enum';
import { RedirectService } from '@shared/services/redirect.service';

@Component({
  selector: 'intello-checkout-layout',
  standalone: true,
  imports: [
    SharedModule,

    MatIconModule,
    MatSelectModule,

    RouterModule
  ],
  templateUrl: './checkout-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./checkout-layout.component.scss']
})
export class CheckoutLayoutComponent extends BaseComponent implements OnInit {

  // -----------------------------------------------------------------------------------------------------
  // @ INPUT VARIABLES
  // -----------------------------------------------------------------------------------------------------

  isForbidden: boolean = false;

  notFound: boolean = false;

  isLoggedIn = signal(false);

  user = signal(null);

  // -----------------------------------------------------------------------------------------------------
  // @ CONSTRUCTOR
  // -----------------------------------------------------------------------------------------------------

  constructor(
    private forbiddenService: ForbiddenService,
    private redirectService: RedirectService,
    private notFoundService: NotFoundService,
    private location: Location,
    private authenticationService: AuthenticationService
  ) {
    super();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ LIFE CYCLE HOOKS
  // -----------------------------------------------------------------------------------------------------

  ngOnInit() {
    super.addSubscription(
      this.forbiddenService
        .isForbidden$
        .subscribe((isForbidden: boolean) => {
          this.isForbidden = isForbidden;
        })
    );

    super.addSubscription(
      this.notFoundService
        .notFound$
        .subscribe((notFound: boolean) => {
          this.notFound = notFound;
          if (notFound === true) {
            this.location.replaceState(AppRoute.Home);
          }
        })
    );

    // Logged in state
    this.isLoggedIn.set(this.authenticationService.isAuthenticated());
    this.user.set(this.authenticationService.credentials?.user);
  }

  logout(): void {
    this.redirectService.setRedirectUri(`${window.location.pathname}${window.location.search}`);
    localStorage.clear();
    this.authenticationService.logout().subscribe();
  }
  // -----------------------------------------------------------------------------------------------------
  // @ PRIVATE METHODS
  // -----------------------------------------------------------------------------------------------------

}
